import request from '@/utils/request'

// 获取用户的角色列表
export function userPermissionsList(data) {
  return request({
    url: '/api/manage/v1/manager/profile/authority',
    method: 'post',
    data
  })
}